import { createContext } from 'react'

/**
 * The id of the label a form row shows (`FormRow`, `shared/forms`), from the mockups'
 * `forms/fieldLabelContext.js`. A field inside the row with no label of its own names itself
 * with it (`aria-labelledby`), so a call site passes no id.
 */
export const FieldLabelContext = createContext<string | null>(null)
